import React, { Component } from 'react';
import RegisteredPhonesPanelContainer from './registered-phones-panel.container'

class AdministratorContainer extends Component {

	componentDidMount () {

	}
	
	render() {
		
		return (			
			<div >			
				  <RegisteredPhonesPanelContainer />
			</div>
		)
	}
}

export default AdministratorContainer;